import { countries, USER_ROLE_OPTIONS } from "../../api/constants";
import { IFormField } from "../../utils/form_factory";

// Phone-based registration form fields
export const UserFormFields = ( otpSent: boolean): IFormField[] => {

    const fields: IFormField[] = [
        {
            name: 'phone_number',
            initailValue: '+256',
            label: 'Phone Number (international)',
            type: 'tel',
            uiType: 'phone',
            uiBreakpoints: { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 },
            required: true,
        },
        {
            name: 'first_name',
            initailValue: '',
            label: 'First Name',
            type: 'text',
            uiType: 'text',
            uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
            required: true,
        },
        {
            name: 'last_name',
            initailValue: '',
            label: 'Last Name',
            type: 'text',
            uiType: 'text',
            uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
            required: true,
        },
        {
            name: 'role',
            initailValue: '',
            label: 'Account Type',
            type: 'select',
            uiType: 'select',
            options: USER_ROLE_OPTIONS,
            uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
            required: true,
        },
        {
            name: 'accept_terms',
            initailValue: true,
            label: 'Accept Terms & Conditions',
            type: 'checkbox',
            uiType: 'checkbox',
            uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
            required: true,
        },
    ];

    if (otpSent) {
        fields.splice(4, 0, {
            name: 'otp_code',
            initailValue: '',
            label: 'OTP Code',
            type: 'text',
            uiType: 'text',
            uiBreakpoints: { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 },
            required: true,
        });
    }

    return fields;
};


// import { countries, genderFields, sourceOfFunds, riskTolerance, DOCUMENT_TYPE_OPTIONS, investmentKnowledge, investmentObjectives , accountTypes, USER_TYPE_OPTIONS} from "../../api/constants";
// import { IFormField } from "../../utils/form_factory";
// import { TUserFormProps } from "./Users.interface";

// export const UserFormFields = (props: TUserFormProps): IFormField[] => {
//     const { banks, handleBankSearch } = props;

//     return [
        // {
        //     name: 'first_name',
        //     initailValue: '',
        //     label: 'First Name',
        //     type: 'text',
        //     uiType: 'text',
        //     uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
        //     required: true,
        // },
        // {
        //     name: 'last_name',
        //     initailValue: '',
        //     label: 'Last Name',
        //     type: 'text',
        //     uiType: 'text',
        //     uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
        //     required: true,
        // },
//         {
//             name: 'email',
//             initailValue: '',
//             label: 'Email',
//             type: 'email',
//             uiType: 'email',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             required: true,
//         },
//         {
//             name: "phone_number",
//             initailValue: "",
//             label: "Phone Number",
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             uiType: "phone",
//             customFormat: "XXX-XXX-XXXXXX",
//             required: true,
//         },
//         {
//             name: 'secondary_phone_number',
//             initailValue: '',
//             label: 'Secondary Phone Number',
//             type: 'text',
//             uiType: 'phone',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6 },
//         },
//         {
//             name: 'account_type',
//             initailValue: '',
//             label: 'Account Type',
//             type: 'select',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             uiType: 'select',
//             options: accountTypes,
//             required: true,
//         },
//         {
//             name: 'user_type',
//             initailValue: '',
//             label: 'User Type',
//             type: 'select',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             uiType: 'select',
//             options: USER_TYPE_OPTIONS,
//             required: true,
//         },
//         {
//             name: 'country',
//             initailValue: '',
//             label: 'Nationality',
//             type: 'select',
//             uiType: 'select',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             options: countries,
//             required: true,
//         },
//         {
//             name: 'city',
//             initailValue: '',
//             label: 'City',
//             type: 'select',
//             uiType: 'text',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             required: true,
//         },
//         {
//             name: 'street',
//             initailValue: '',
//             label: 'Street',
//             type: 'text',
//             uiType: 'text',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6 },
//         },
//         {
//             name: 'plot_number',
//             initailValue: '',
//             label: 'Plot Number',
//             type: 'text',
//             uiType: 'text',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6 },
//         },
//         {
//             name: 'postal_code',
//             initailValue: '',
//             label: 'Postal Code',
//             type: 'text',
//             uiType: 'text',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6 },
//         },
//         {
//             name: 'postal_address',
//             initailValue: '',
//             label: 'Postal Address',
//             type: 'text',
//             uiType: 'text',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6 },
//         },
//         {
//             name: 'dateofbirth',
//             initailValue: '',
//             label: 'Date of Birth',
//             uiType: 'date',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             required: true,
//         },
//         {
//             name: 'nin',
//             initailValue: '',
//             label: 'NIN',
//             type: 'text',
//             uiType: 'text',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6 },
//         },
//         {
//             name: 'id_type',
//             initailValue: '',
//             label: 'ID Type',
//             type: 'select',
//             uiType: 'select',
//             options: DOCUMENT_TYPE_OPTIONS,
//             uiBreakpoints: { xs: 12, sm: 12, md: 6 },
//         },
//         {
//             name: 'id_front',
//             initailValue: '',
//             label: 'ID Front',
//             type: 'file',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             uiType: 'file',
//             accepts: 'image/*',
//             required: true,
//         },
//         {
//             name: 'id_back',
//             initailValue: '',
//             label: 'ID Back',
//             type: 'file',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             uiType: 'file',
//             accepts: 'image/*',
//             required: true,
//         },
//         {
//             name: 'gender',
//             initailValue: '',
//             label: 'Gender',
//             type: 'select',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             uiType: 'select',
//             options: genderFields,
//             required: true,
//         },

//         // {
//         //     name: 'bank',
//         //     initailValue: '',
//         //     label: 'Current/Former Bank',
//         //     type: 'select',
//         //     uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//         //     uiType: 'select',
//         //     options: banks,
//         //     required: true,
//         //     handleSearch: handleBankSearch
//         // },
//         {
//             name: 'photo',
//             initailValue: '',
//             label: 'Profile photo',
//             type: 'file',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             uiType: 'file',
//             accepts: 'image/*',
//             required: true,
//         },
//         {
//             name: 'source_of_funds',
//             initailValue: '',
//             label: 'Source of Funds',
//             type: 'select',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             uiType: 'select',
//             options: sourceOfFunds,
//             required: true,
//         },
//         {
//             name: 'investment_objective',
//             initailValue: '',
//             label: 'Investment Objective',
//             type: 'select',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             uiType: 'select',
//             options: investmentObjectives,
//             required: true,
//         },
//         {
//             name: 'investment_knowledge',
//             initailValue: '',
//             label: 'Investment Knowledge',
//             type: 'select',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             uiType: 'select',
//             options: investmentKnowledge,
//             required: true,
//         },
//         {
//             name: 'investment_risk',
//             initailValue: '',
//             label: 'Risk Tolerance',
//             type: 'select',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             uiType: 'select',
//             options: riskTolerance,
//             required: true,
//         },
//         {
//             name: 'password',
//             initailValue: '',
//             label: 'Password',
//             type: 'password',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             uiType: 'password',
//             required: true,
//         },
//         {
//             name: 'confirm_password',
//             initailValue: '',
//             label: 'Confirm Password',
//             type: 'password',
//             uiBreakpoints: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
//             uiType: 'password',
//             required: true,
//         },
//     ]
// }